export let CountryType = /*#__PURE__*/function (CountryType) {
  CountryType["OFFICIALLY_ASSIGNED"] = "OFFICIALLY_ASSIGNED";
  CountryType["EXCEPTIONALLY_RESERVED"] = "EXCEPTIONALLY_RESERVED";
  CountryType["TRANSITIONALLY_RESERVED"] = "TRANSITIONALLY_RESERVED";
  CountryType["INDETERMINATELY_RESERVED"] = "INDETERMINATELY_RESERVED";
  CountryType["FORMERLY_USED"] = "FORMERLY_USED";
  CountryType["UNASSIGNED"] = "UNASSIGNED";
  return CountryType;
}({});
export const exceptionallyReservedCountries = {
  SU: {
    es: 'URSS',
    en: 'USSR',
    fr: 'URSS',
    ca: 'URSS'
  }
};
export const transitionallyReservedCountries = {
  AN: {
    es: 'Antillas Holandesas',
    en: 'Netherlands Antilles',
    fr: 'Antilles Néerlandaises',
    ca: 'Antillas Holandesas'
  },
  BU: {
    es: 'Burma',
    en: 'Burma',
    fr: 'Burma',
    ca: 'Burma'
  },
  CS: {
    es: 'Serbia y Montenegro',
    en: 'Serbia and Montenegro',
    fr: 'Serbie et Monténégro',
    ca: 'Serbia y Montenegro'
  },
  NT: {
    es: 'Zona Neutral',
    en: 'Neutral Zone',
    fr: 'Zone Neutre',
    ca: 'Zona Neutral'
  },
  TP: {
    es: 'Timor Oriental',
    en: 'East Timor',
    fr: 'Timor Oriental',
    ca: 'Timor Oriental'
  },
  YU: {
    es: 'Yugoslavia',
    en: 'Yugoslavia',
    fr: 'Yugoslavia',
    ca: 'Yugoslavia'
  },
  ZR: {
    es: 'República del Zaire',
    en: 'Zaire',
    fr: 'République du Zaïre',
    ca: 'República del Zaire'
  }
};